import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentQueryId } from 'ducks/searches/selectors'
import { doRedirectToDefaultCollectionAndFolder } from 'ducks/folders/operations/collections'
import AutoLayout from 'subapps/chat/components/AutoLayout'
import RoomListWithHeader from 'subapps/chat/components/RoomListWithHeader'
import Chat from 'subapps/chat/components/Chat'
import RightSidebar from 'components/App/DesktopView/Layout/RightSidebar'

const COLUMN_CONFIGS = {
  '3-overview': [0],
  '3-page': [1, 2],
  '4': [0, 1, 2],
}

export default function ChatPage({ roomId, eventId }) {
  const dispatch = useDispatch()
  const currentQueryId = useSelector(selectCurrentQueryId)
  useEffect(
    () => {
      if (!currentQueryId) dispatch(doRedirectToDefaultCollectionAndFolder())
    },
    [currentQueryId, dispatch]
  )

  return (
    <AutoLayout conversationId={roomId} columnConfigs={COLUMN_CONFIGS}>
      <RoomListWithHeader />
      {roomId ? <Chat roomId={roomId} eventId={eventId} /> : <div />}
      <RightSidebar />
    </AutoLayout>
  )
}
